import { render, staticRenderFns } from "./LogisticsDashboard.vue?vue&type=template&id=ae7ee37e&scoped=true"
import script from "./LogisticsDashboard.vue?vue&type=script&lang=js"
export * from "./LogisticsDashboard.vue?vue&type=script&lang=js"
import style0 from "./LogisticsDashboard.vue?vue&type=style&index=0&id=ae7ee37e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae7ee37e",
  null
  
)

export default component.exports